import React from 'react';
import PropTypes from 'prop-types';
import { useChaperone } from './Hooks';
import { settingBackground, styler } from './Utils';

const TriggerProps = {
	as: PropTypes.elementType,
	id: PropTypes.string,
	index: PropTypes.number,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	allowTransition: PropTypes.bool,
};

const TriggerDefaults = {
	index: 0,
	allowTransition: false,
};

export const Trigger = ({
	as: Component = 'a',
	id,
	label,
	index,
	allowTransition,
	...props
}) => {
	const {
		chaperone: { index: currentIndex, currentId },
		setChaperone,
	} = useChaperone();
	const handlerClick = (e) => {
		e.preventDefault();
		if (index === currentIndex && id === currentId) return;
		const target = e.target;
		const execute = () =>
			setChaperone({
				index,
				matched: false,
				skip: false,
				done: false,
				currentId: id,
				previousIndex: -1,
			});
		if(allowTransition) {
			setTimeout(() => {
				execute();
				target.removeAttribute('style');
			}, 300);
			styler(target, {
				zIndex: 1000000,
				position: 'relative',
				pointerEvents: 'none',
			});
			settingBackground(target, false, false, 1, 1000);
		} else {
			execute();
		} 
	};
	return (
		<Component
			href=''
			{...props}
			data-chaperone-trigger='true'
			onClick={handlerClick}>
			{label}
		</Component>
	);
};

Trigger.propTypes = TriggerProps;

Trigger.defaultProps = TriggerDefaults;
